<template>
  <div>
    <b-row align-v="center">
      <b-col md="4">
        <b-alert show :variant="scoreCheckAlertVariant" align="center">
          <b-row align-v="center">
            <b-col md="3">
              <font-awesome-icon
                v-if="distressViable"
                :icon="['far','check-circle']"
                size="5x"
              />
              <font-awesome-icon
                v-if="!distressViable"
                :icon="['far','times-circle']"
                size="5x"
              />
            </b-col>
            <b-col>
              {{ scoreCheckText }}
            </b-col>
          </b-row>
        </b-alert>
      </b-col>

      <b-col>
        <ScoreCheckChartPlotly
          :rankings="renewalRankings"
          :current-option="renewalOption"
          :current-option-is-recommended="distressViable && scoreAllowsRecommendation"
        />
      </b-col>
    </b-row>



    <div v-if="disqualifyingDistresses.length > 0">
      <h5>Disqualifying Distresses</h5>
      <p>A distress is ‘disqualifying’ if its presence and severity are not appropriately addressed by a given treatment. Although multiple disqualifying distresses are possible, a single distress may disqualify a treatment.</p>
      <b-table :fields="distressTableKeys" :items="disqualifyingDistresses">
        <template slot="name" slot-scope="data">
          {{ distressInfo[data.item.key].name }}
        </template>
        <template slot="severityCode" slot-scope="data">
          <div style="text-align:center;">
            {{ data.item.severityCode }}
          </div>
        </template>
        <template slot="description" slot-scope="data">
          {{ distressInfo[data.item.key].descriptionBasic }}
        </template>
        <template slot="severity" slot-scope="data" style="text-align: right">
          <!--<font-awesome-icon :icon="['far', 'times-circle']"-->
          <!--v-if="data.item.points===-1"/>-->
          <!--&nbsp&nbsp {{data.item.points}}-->
          <!--&nbsp&nbsp 0-->
          <div style="text-align:center;">
            &#8212;
          </div>
        </template>
      </b-table>
    </div>

    <h5>Contributing Distresses</h5>
    <p>The presence and severity of distresses affect how RxPave determines which treatments are most appropriate. Larger positive scores indicate that a treatment is more appropriate, and only treatments at or within 1 point of the top score are considered viable options. RxPave calculates scores for all treatment, even if disqualified.</p>
    <b-table :fields="distressTableKeys" :items="nonDisqualifyingDistresses" responsive>
      <template slot="name" slot-scope="data">
        {{ distressInfo[data.item.key].name }}
      </template>
      <template slot="severityCode" slot-scope="data">
        <div style="text-align:center;">
          {{ data.item.severityCode }}
        </div>
      </template>
      <template slot="description" slot-scope="data">
        {{ distressInfo[data.item.key].descriptionBasic }}
      </template>
      <template slot="severity" slot-scope="data">
        <div style="text-align:center;">
          <font-awesome-icon v-if="data.item.points===-1"
                             :icon="['far', 'times-circle']"
          />
          <font-awesome-icon v-if="data.item.points===0"
                             :icon="['far', 'circle']"
          />
          <font-awesome-icon v-if="data.item.points===1"
                             :icon="['far', 'adjust']"
          />
          <font-awesome-icon v-if="data.item.points===2"
                             :icon="['far', 'dot-circle']"
          />
          <!--{{data.item.severity}}-->
          &nbsp {{ data.item.points }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>

  import ScoreCheckChartPlotly from './ScoreCheckChartPlotly'

  import { distressInfo } from './../../../../js/distress/distressTypeData'

  export default {
    name: "DistressScoreReport",
    components: {
      ScoreCheckChartPlotly
    },
    props: {
      renewalOption: String,
      optionData: Object,
      renewalRankings: Array,
      scoreAllowsRecommendation: Boolean,
      distressScores: Object,
      distressViable: Boolean
    },
    data: function() {
      return {
        distressTableKeys: [
          'name',
          {key: 'severityCode', label: 'Severity'},
          {key: 'description', label: 'Description'},
          {key: 'severity', label: 'Scoring'}
        ],
        distressInfo: distressInfo
      }
    },
    computed: {
      disqualifyingDistresses: function() {
        const filtered = Object.entries(this.distressScores).filter((kv) => kv[1]['isDisqualifying'] )
          .map(x => x[1]);
        return filtered.sort(this.compareDistresses);
      },
      nonDisqualifyingDistresses: function() {
        const filtered = Object.entries(this.distressScores).filter((kv) => !kv[1]['isDisqualifying'] )
          .map(x => x[1]);
        return filtered.sort(this.compareDistresses);
      },
      scoreCheckText() {
        // Create a response based only on score rankings
        const scoreText = this.scoreAllowsRecommendation ?
          (
            this.optionData.name + " is a recommended treatment because it is a top scoring option."
          ):(
            this.optionData.name +  " is not a recommended treatment because it is not a top scoring option."
          );

        // Return the score rank text only if this option is not disqualified.
        if (this.disqualifyingDistresses.length > 0){
          return this.optionData.name + " is not a recommended treatment because this section has" +
            " disqualifying distress types."
        } else {
          return scoreText
        }
      },
      scoreCheckAlertVariant() {
        return (this.scoreAllowsRecommendation && this.disqualifyingDistresses.length === 0) ? "success" : "danger"
      },

    },
    methods: {
      compareDistresses: function(a, b) {
        /*
        Sort distresses by severity, high-to-low.
         */
        const aSortKey = a['severity'];
        const bSortKey = b['severity'];
        if (aSortKey > bSortKey){
          return -1
        }
        if (aSortKey < bSortKey){
          return 1
        }
        return 0
      }
    }
  }
</script>

<style scoped>

</style>